import './summary.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Column,
  Grid,
  Row
} from 'cdk-radial';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';


const inUSDCurrency = (value)=>{
  return (value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  })
}
function SummaryCard(props) {
  const LOCATION = "Location(s)";
  const { tax, isFailedToCalculateTax, isLoadingToCalculateTax } = props
  const state = useSelector(state => state);
  const { selectedLocations } = state.selectLocationsSlice;
  const { overview: { name, publisherName } = {} } = state.solutionInfoSlice.solutionInfo;
  const planDetails = state.solutionInfoSlice.planDetails;
  const selectedPlanId=state.solutionInfoSlice.selectedPlanId;
  let filteredPlan = [];
  let planAmountText = '';
  let totalSubAmmount = '';
  let totalAmmount = '';
  let salesTax = '';
  let planFrequencyText = '';
  let taxRate = '';
  let planId ='';
  (selectedPlanId && selectedPlanId !== '') 
    ? planId=selectedPlanId 
    : planId=props.match && props.match.params && props.match.params.selectedPlanId;
  
  if (Array.isArray(planDetails) && planDetails.length > 0) {
    filteredPlan = planDetails.filter(plan => {
      return plan.id === planId;
    });
    if (Array.isArray(filteredPlan) && filteredPlan.length > 0) {
      if (
        filteredPlan[0].isFreeTrialEnabled ||
        filteredPlan[0].isTheFreeTrial
      ) {
        planAmountText = `${filteredPlan[0].basePrice}`;
        planFrequencyText = `${filteredPlan[0].planName}`;
      } else if (filteredPlan[0].billingType === 'RECURRING') {
        planAmountText = `${filteredPlan[0].basePrice}`;
        planFrequencyText = `per ${filteredPlan[0].billingFrequency}`.toLowerCase();
      }
    }
  }

  let selectedLocationsCount = selectedLocations ? selectedLocations.length : 0
  planAmountText = parseInt(planAmountText)
  if (!tax && !isLoadingToCalculateTax && !isFailedToCalculateTax) {
    totalSubAmmount = inUSDCurrency(planAmountText * selectedLocationsCount)
    planAmountText = inUSDCurrency(planAmountText)
    salesTax = '0.00'
    totalAmmount = totalSubAmmount
    taxRate = '0.00'
  } else if (tax && tax.rate !== 0) {
    planAmountText = inUSDCurrency(planAmountText)
    totalSubAmmount =inUSDCurrency(tax.taxable_amount)
    salesTax = inUSDCurrency(tax.amount_to_collect)
    taxRate = (tax.rate * 100).toFixed(2)
    totalAmmount = inUSDCurrency(tax.taxable_amount + tax.amount_to_collect)
  } else if(tax && tax.rate ===0){
    planAmountText = inUSDCurrency(planAmountText)
    totalSubAmmount =inUSDCurrency(tax.order_total_amount)
    salesTax = inUSDCurrency(tax.amount_to_collect)
    taxRate = (tax.rate * 100).toFixed(2)
    totalAmmount = inUSDCurrency(tax.order_total_amount)
  }

  return (
    <SkeletonTheme color="#c0c0c1" highlightColor="#eee">
      <div className="payment-summary-heading">
        <div className="payment-summary-solution">
          {`Subscribe to ${name || ''}`}
        </div>
        <div className="payment-summary-text">
          {`Published by ${publisherName || ''}`}
        </div>
      </div>
      <div className="payment-summary-price">
        {isLoadingToCalculateTax
          ? <Skeleton height={40} width={150} />
          : <>
            <div className="payment-summary-details-price-head">{`${totalAmmount}`}</div>
            <div className="payment-summary-details-price-subHead">
              {planFrequencyText}
            </div>
          </>
        }
        <div className="payment-summary-text">
          {`Prices may vary according to billing address.`}
        </div>
      </div>

      <div className='summary-box-margin'>
        {isLoadingToCalculateTax && <Grid>
          <Row className='border-bottom'>
            <Column
              l={6}
            >
              <div className="payment-summary-table-text">
                {`Summary`}
              </div>
            </Column>
          </Row>
          <Row >
            <Column l={12}>
              <Skeleton height={30} />
            </Column>
          </Row>
          <Row className='border-bottom'>
            <Column l={12}>
              <Skeleton height={30} />
            </Column>
          </Row>
          <Row >
            <Column l={12}>
              <Skeleton height={30} />
            </Column>
          </Row>
        </Grid>
        }
        {!isLoadingToCalculateTax && <Grid >
          <Row className='border-bottom'>
            <Column
              l={6}
            >
              <div className="payment-summary-table-text">
                {`Summary`}
              </div>
            </Column>
          </Row>
          <Row>
            <Column
              l={6}
            >
              <div className="payment-summary-info">
                {`Sub total`}
              </div>
              <div className="payment-summary-details-total-subHead">
                {`${selectedLocationsCount} ${LOCATION} x ${planAmountText}`}
              </div>
            </Column>
            <Column
              l={6}
            >
              <div className="payment-summary-info-value">
                {`${totalSubAmmount}`}
              </div>
            </Column>

          </Row>
          <Row className='border-bottom'>
            <Column
              l={6}
            >
              <div className="payment-summary-info">
                {`Sales Tax`}
              </div>
              <div className="payment-summary-details-total-subHead">
                {`${taxRate}%`}
              </div>
            </Column>
            <Column
              l={6}
            >
              <div className="payment-summary-info-value">
                {`${salesTax}`}
              </div>
            </Column>
          </Row>
          <Row>
            <Column
              l={6}
            >
              <div className="payment-summary-info">
                {`Total`}
              </div>
            </Column>
            <Column
              l={6}
            >
              <div className="payment-summary-info-value">
                {`${totalAmmount}`}
              </div>
            </Column>
          </Row>
        </Grid>}
      </div>

    </SkeletonTheme>
  );
}
export default withRouter(SummaryCard);
